import React, { useState } from 'react';
import { Container, Card, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import RelCentroCustoService from '~/Services/GES/RelCentroCustoService';
import FormFiltros from './components/FormFiltros';
import TabelaIndentada from './components/TabelaIndentada';
import BotoesExport from './components/BotoesExport';

const FILTROS_INICIAIS = { categoria: '', status: '' };

const CentroCustoPage = () => {
  const [filtros, setFiltros] = useState(FILTROS_INICIAIS);
  const [dados, setDados] = useState(null);
  const [truncado, setTruncado] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  const handleGerar = async () => {
    setErro('');
    setCarregando(true);
    try {
      const payload = {
        categoria: filtros.categoria || null,
        status: filtros.status || null,
      };
      const resultado = await RelCentroCustoService.gerar(payload);
      const linhas = Array.isArray(resultado) ? resultado : [];
      setDados(linhas);
      setTruncado(linhas.some((r) => r.truncado === true));
      if (linhas.length === 0) {
        setErro('Nenhum centro de custo encontrado.');
      }
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao gerar relatório.';
      setErro(msg);
      toast.error(msg);
    } finally {
      setCarregando(false);
    }
  };

  const filtrosParaExport = {
    categoria: filtros.categoria || null,
    status: filtros.status || null,
  };

  return (
    <Container fluid className="py-3">
      <Header title="Relatório de Centro de Custo" />

      <Card className="mt-3">
        <Card.Body>
          <FormFiltros
            filtros={filtros}
            onChange={setFiltros}
            onGerar={handleGerar}
            carregando={carregando}
          />
        </Card.Body>
      </Card>

      {carregando && <Loading label="Gerando relatório..." />}

      {!carregando && erro && (
        <Alert variant="warning" className="mt-3">
          {erro}
        </Alert>
      )}

      {!carregando && dados !== null && dados.length > 0 && (
        <div className="mt-3">
          {truncado && (
            <Alert variant="info">
              Hierarquia trunca em 4 níveis — registros com profundidade superior não são exibidos.
            </Alert>
          )}

          <div className="d-flex justify-content-end mb-2">
            <BotoesExport filtros={filtrosParaExport} desabilitado={false} />
          </div>

          <TabelaIndentada dados={dados} />

          <small className="text-muted">
            Total: {dados.length} registro(s)
          </small>
        </div>
      )}
    </Container>
  );
};

export default CentroCustoPage;
